/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PasskeyLoginVerifyForm { 
    /**
     * Session ID della sessione di login passkey (UUID emesso da /login/options)
     */
    session_id: string;
    /**
     * Credential ID codificato in Base64URL
     */
    credential_id: string;
    /**
     * Authenticator data codificato in Base64URL
     */
    authenticator_data: string;
    /**
     * Client data JSON codificato in Base64URL
     */
    client_data_json: string;
    /**
     * Firma digitale codificata in Base64URL
     */
    signature: string;
}